import React, { useEffect, useRef } from 'react';
import { useQueryParamString } from 'react-use-query-param-string';

import { AnyProps } from '../types';
import { blokToComponent } from '../helpers';

const setAdditionalFields = (form, fields = {}) => {
  if (!form || typeof form.setAdditionalFormFields !== 'function') return;
  form.setAdditionalFormFields(fields);
};

export const RocheOrderTrainingMaterial = ({ blok, getComponent, slot }: AnyProps): JSX.Element => {
  const element = useRef(null);
  const formElement = useRef(null);

  const [productNameQueryParam] = useQueryParamString('ProductName', '');
  const [productIdQueryParam] = useQueryParamString('ProductId', '');

  useEffect(() => {
    formElement.current = element.current?.querySelector('roche-form');
    const queryObj = {
      ProductName: productNameQueryParam,
      ProductId: productIdQueryParam,
    };
    setAdditionalFields(formElement.current, queryObj);
  }, []);

  return (
    <div slot={slot} ref={element}>
      {productNameQueryParam && <roche-headline headline={productNameQueryParam} level={4} />}
      {blok.slotted_form && blok.slotted_form[0] && blokToComponent({ blok: blok.slotted_form[0], getComponent }, 'roche-email-form')}
    </div>
  );
};
